import { getOperationName } from '@apollo/client/utilities'
import { Button, message } from 'antd'
import React from 'react'

import {
  GetGroupFollowersDocument,
  GetGroupMemberRequestDocument,
  GetUnreadMemberRequestsDocument,
  useGroupMemberRequestApproveMutation,
} from '@/generated/graphql'

export const GroupReplyButton: React.FC<{ requestId: number; name: string; disabled?: boolean }> = ({
  requestId,
  name,
  disabled = false,
}) => {
  const [groupMemberRequestApprove] = useGroupMemberRequestApproveMutation({
    refetchQueries: [
      getOperationName(GetGroupFollowersDocument)!,
      getOperationName(GetUnreadMemberRequestsDocument)!,
      getOperationName(GetGroupMemberRequestDocument)!,
    ],
  })

  const onClick = (requestId: number, isApproved: boolean, name: string) => async () => {
    const result = await groupMemberRequestApprove({ variables: { requestId, isApproved } })
    if (result.data) {
      if (result.data.groupMemberRequestApprove.alreadyApproved) {
        message.warn('该申请已被其他管理员处理')
      } else {
        if (result.data.groupMemberRequestApprove.requesetHandled) {
          message.info(`${name}申请已${isApproved ? '同意' : '拒绝'}`)
        } else {
          message.error('该成员已在群组中')
        }
      }
    }
  }
  return (
    <div>
      <Button disabled={disabled} danger onClick={onClick(requestId, false, name)}>
        拒绝
      </Button>
      <Button disabled={disabled} type='primary' style={{ marginLeft: 8 }} onClick={onClick(requestId, true, name)}>
        同意
      </Button>
    </div>
  )
}
